import React from 'react'
import { MdOutlineArrowLeft } from "react-icons/md";

const Sweets = () => {
  return (
    <>
      <section class="text-gray-600 body-font">
        <div class="container px-5 py-24 mx-auto">
          <div class="flex flex-wrap w-full mb-20">
            <div class="lg:w-1/2 w-full mb-6 lg:mb-0">
              <h1 class="sm:text-3xl text-2xl font-medium title-font mb-2 text-gray-900">
                Sweet Cuisines
              </h1>
              <div class="h-1 w-20 bg-indigo-500 rounded"></div>
              <div className="flex  text-start">
                <MdOutlineArrowLeft className="lg:w-[25px] lg:h-[25px] " />
                <a href="/menu">
                  <p className="text-blue-700">Back</p>
                </a>
              </div>
            </div>
            {/* <p class="lg:w-1/2 w-full leading-relaxed text-gray-500">Whatever cardigan tote bag tumblr hexagon brooklyn asymmetrical gentrify, subway tile poke farm-to-table. Franzen you probably haven't heard of them man bun deep jianbing selfies heirloom prism food truck ugh squid celiac humblebrag.</p> */}
          </div>
          <div class="tourney lg:grid lg:grid-cols-6 grid grid-cols-2 -m-4 mx-2 mt-0.5 text-center  ">
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Sweets\Gulab Jamun.webp"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  Gulab Jamun
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Sweets\Rasgulla.webp"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  Rasgulla
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Sweets\Jalebi.jpg"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  Jalebi
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Sweets\Kaju Katli.jpg"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  Kaju Katli
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Sweets\Mysore Pak.webp"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  Mysore Pak
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Sweets\Obbattu (Holige).jpg"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  Obbattu (Holige)
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Sweets\laddu.webp"
                    alt="LADDU"
                    name="?"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  LADDU
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Sweets\Coconut Burfi.jpg"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  Coconut Burfi
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Sweets\Khova Puri.jpg"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  Khova Puri
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Sweets\Pineapple Kesari Bath.jpg"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  Pineapple Kesari Bath
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Sweets\Balushahi.avif"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  Balushahi
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Sweets\Peda.webp"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  Peda
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Sweets\Champakali.jpg"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  Champakali
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Sweets\Rasmalai.webp"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  Rasmalai
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Sweets\Gajar Ka Halwa.webp"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  Gajar Ka Halwa
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Sweets\Shavige Payasa.jpg"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  Shavige Payasa
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Sweets\Gasa Gase Payasa.jpg"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  Gasa Gase Payasa
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Sweets\Shahi Tukda.jpg"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  Shahi Tukda
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Sweets